import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { LogViewModel } from "../../features/log/log-view-model";
import { AppRoutes } from "../../routes/routes";
import { useViewModel } from "../../viewmodel/use-view-model";
export const LogAlert = observer(() => {
    const { t } = useTranslation();
    const vm = useViewModel(LogViewModel);
    return (_jsx("div", { className: "position-relative z-2", children: _jsxs("div", { className: "position-absolute top-0 end-0 mt-3 me-3", children: [errorPart(vm, t), successPart(vm, t)] }) }));
});
function successPart(vm, t) {
    if (!vm.lastSuccess) {
        return _jsx(_Fragment, {});
    }
    return (_jsxs("div", { className: "alert alert-success alert-dismissible fade show justify-content-center align-items-center shadow-sm", role: "alert", children: [vm.lastSuccess.localizedKey &&
                t(vm.lastSuccess.localizedKey), !vm.lastSuccess.localizedKey &&
                vm.lastSuccess.message, _jsx("button", { type: "button", className: "btn-close", "aria-label": t("errors.alertClose"), onClick: (evt) => {
                    evt.preventDefault();
                    evt.stopPropagation();
                    vm.clearLastSuccess();
                } })] }));
}
function errorPart(vm, t) {
    if (!vm.lastError) {
        return _jsx(_Fragment, {});
    }
    const status = Number(vm.lastError.apiError?.status);
    let content;
    if (status === 401) {
        content = (_jsx(Trans, { i18nKey: "errors.alertUnauthorized", children: _jsx(Link, { to: AppRoutes.OAuthLogin, onClick: () => vm.clearLastError() }) }));
    }
    else if (status === 403) {
        content = (_jsx(Trans, { i18nKey: "errors.alertForbidden", children: _jsx(Link, { to: AppRoutes.Errors, onClick: () => vm.clearLastError() }) }));
    }
    else {
        content = (_jsx(Trans, { i18nKey: "errors.alertTitle", children: _jsx(Link, { to: AppRoutes.Errors, onClick: () => vm.clearLastError() }) }));
    }
    return (_jsxs("div", { className: "alert alert-danger alert-dismissible fade show justify-content-center align-items-center shadow-sm", role: "alert", children: [content, _jsx("button", { type: "button", className: "btn-close", "aria-label": t("errors.alertClose"), onClick: (evt) => {
                    evt.preventDefault();
                    evt.stopPropagation();
                    vm.clearLastError();
                } })] }));
}
